import React from 'react';
import { Link } from 'react-router-dom';
import { Type } from '@spotify-internal/encore-creator-web';
import { EmailUnsubscribeHeader, Content } from './';
import { Footer } from '../LandingPage/Footer';

export function UnsubscribeSuccess() {
  return (
    <>
      <EmailUnsubscribeHeader />
      <Content>
        <Type as="h1" variant={Type.heading2} weight={Type.bold}>
          You unsubscribed from our marketing emails.
        </Type>
        <Type as="p" variant={Type.body1}>
          You can <strong>resubscribe</strong> anytime by going to your{' '}
          <Link to="/settings">User Settings</Link>.
        </Type>
      </Content>
      <Footer />
    </>
  );
}
